import Welcome from "../../pages/onboarding/welcome";
import VerifyEmail from "../../pages/onboarding/verify-email";
import ProfileCompletion from "../../pages/onboarding/profile-completion";
import OAuthCallback from "../../pages/onboarding/oauth-callback";
export var Onboarding_Routes = [
    {
        PATH: 'welcome',
        COMPONENT: Welcome,
        isProtected: false,
    },
    {
        PATH: 'verify-email',
        COMPONENT: VerifyEmail,
        isProtected: false,
    },
    {
        PATH: "profile-completion",
        COMPONENT: ProfileCompletion,
        isProtected: false,
    },
    {
        PATH: "oauth/callback",
        COMPONENT: OAuthCallback,
        isProtected: false,
    },
    /* {
      PATH: '/onboarding/account-setup',
      COMPONENT: <AccountSetup />,
      isProtected: false,
    },
    {
      PATH: '/onboarding/company-verification',
      COMPONENT: <CompanyVerification />,
      isProtected: false,
    },
    {
      PATH: '/onboarding/profile-completion',
      COMPONENT: <ProfileCompletion />,
      isProtected: false,
    },
    {
      PATH: '/onboarding/success',
      COMPONENT: <Success />,
      isProtected: false,
    },
    {
      PATH: '/*',
      COMPONENT: <PageNotFound />,
      isProtected: false,
    }, */
];
